import { yup } from '@framework/validation/initYup.ts';

export interface IOutcomeActionDirective {}

export const OutcomeActionDirectiveSchema: yup.ObjectSchema<IOutcomeActionDirective> =
  yup.object({}).noUnknown();
